import { render, staticRenderFns } from "./MemberTable.vue?vue&type=template&id=0cc517ca&scoped=true&"
import script from "./MemberTable.vue?vue&type=script&lang=js&"
export * from "./MemberTable.vue?vue&type=script&lang=js&"
import style0 from "./MemberTable.vue?vue&type=style&index=0&id=0cc517ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc517ca",
  null
  
)

export default component.exports